import BaseWidget from './baseWidget.js';

/**
 * Zeigt das hochgeladene Firmenlogo aus den Unternehmensstammdaten.
 * Bei fehlendem Logo wird ein Hinweis angezeigt.
 */
export default class CompanyLogoWidget extends BaseWidget {
	async onRender() {
		this.bodyEl.innerHTML = `
			<div class="widget-company-logo">
				<img src="/neolohn/api/unternehmen/logo" alt="Firmenlogo" />
			</div>
		`;
		const img = this.bodyEl.querySelector('img');
		img.addEventListener('error', () => {
			this.setEmpty('Kein Firmenlogo hinterlegt.');
		});
	}
}
